const PropTypes = require('prop-types');

class LinkModel {
  constructor() {
    this.url = null;
    this.linkText = null;
  }
  deserialise(data) {
    this.url = data.url;
    this.linkText = data.link_text;
    return this;
  }
}

LinkModel.propTypes = PropTypes.shape({
  url: PropTypes.string,
  linkText: PropTypes.string.isRequired,
});

module.exports = LinkModel;
